setPaymentData